import InputBoilerplate from "../InputBoilerplate";

function ShortTextInput({label, value, placeholder, setState, disabled}) {
  return (
    <InputBoilerplate 
        label={label}
        type={'text'}
        value={value}
        placeholder={placeholder}
        setState={setState}
        disabled={disabled}
    />
  )
}

export default ShortTextInput